import { Col, DatePicker, Form, Row } from "antd";
import type React from "react";
import styled from "styled-components";

const CustomDatePicker = styled(DatePicker)`
	.ant-picker-input > input {
		text-align: center;
	}
`;

type MemberSinceDateRangeFilterProps = {};

export const MemberSinceDateRangeFilter: React.FC<
	MemberSinceDateRangeFilterProps
> = () => {
	return (
		<Row gutter={[16, 16]} justify="start">
			<Col xs={{ span: 24 }}>
				<Form.Item className="mb-0">
					<Form.Item
						help="この日付から"
						name="memberSinceMin"
						className="inline-block mr-2 mb-4"
						style={{ width: "calc(50% - 0.25rem)" }}
					>
						<CustomDatePicker
							placeholder="日付で検索"
							className="w-full"
							inputReadOnly
						/>
					</Form.Item>
					<Form.Item
						help="この日付まで"
						name="memberSinceMax"
						className="inline-block mb-4"
						style={{ width: "calc(50% - 0.25rem)" }}
					>
						<CustomDatePicker
							placeholder="日付で検索"
							className="w-full"
							inputReadOnly
						/>
					</Form.Item>
				</Form.Item>
			</Col>
		</Row>
	);
};
